module.exports = __webpack_public_path__ + "static/media/management.c9cffcc1.png";